/**
 * Asynchronously loads the component for PiecripBuySellPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripBuySellPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripBuySellPage
);
